import { Component, OnInit, ViewChild } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
// import { ConfirmationComponent } from "../../../common/components/confirmation/confirmation.component";
import { AboutService } from "../about/about.service";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import Swal from "sweetalert2";
import { RESPONSE } from "src/app/common/common.const";

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  // @ViewChild("myckeditor") ckeditor: any;
  ckeConfig: any;

  aboutContact: string = 'Contact Us';
  id: string = '';
  type: number = 2;
  text: string = '';



  constructor(
    private modalService: NgbModal,
    private AboutService: AboutService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) { }
  ngOnInit() {
    this.getAboutdata();
  }

  getAboutdata() {
    let query = "status=2";

    this.AboutService.getAbout(query).subscribe(data => {
      if (data["message"] = "Success") {

        this.text = data.data[0].text;
        this.id = data.data[0]._id;
      }
    });

  }
  finalSubmit() {
    let value = {
      text: this.text,
      status: this.type
    }
    this.AboutService.saveAbout(value).subscribe(res => {
      if (res["message"] = "Success") {
        Swal.fire("Success", "Saved successfully!", "success");
      }
      else {
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    });
  }
}

